.contentField {
	display: flex;
	flex-direction: column;
	align-items: left;

	width: 100%;
	gap: 10px;

	.contentFieldHeader {
		display: flex;
		flex-direction: column;
		align-items: left;

		gap: 5px;
	}

	.contentFieldTitle {
		font-weight: 500;
		font-size: 14px;
		letter-spacing: 0;
		line-height: 20px;
		color: #262626;
	}

	.contentFieldSubTitle {
		font-weight: 400;
		font-size: 14px;
		line-height: 20px;
		letter-spacing: 0;
		color: #525252;
	}

	&.horizontal {
		display: grid;
		grid-template-columns: 1fr 1fr;
		align-items: center;

		width: 100%;
		gap: 30px;

		.contentFieldHeader {
			display: flex;
			flex-direction: column;
			align-items: left;
		}
	}
}
